import { createFileRoute } from "@tanstack/react-router";
import React, { Suspense, lazy } from "react";
import SiteHeader from "@/components/common/SiteHeader";
import { useBuildingDetailQuery } from "@/queries/queries";

// Wave-17 Item 1.1 — LL88 filing wizard lazy-loaded.
const LL88SubmissionPage = lazy(
  () => import("@/pages/Filings/LL88Submission/Filing/Page"),
);

const LL88SubmissionRoute = () => {
  const { buildingId, ll88SubmissionId } = Route.useParams();
  const { data } = useBuildingDetailQuery(buildingId);
  return (
    <div className="flex flex-col w-full min-h-full">
      <SiteHeader
        header={`${data?.name || "Building"} - LL88 Filing`}
        backLink={`/buildings/${buildingId}`}
      />
      <Suspense fallback={null}>
        <LL88SubmissionPage
          buildingId={buildingId}
          submissionId={ll88SubmissionId}
        />
      </Suspense>
    </div>
  );
};

export const Route = createFileRoute(
  "/buildings_/$buildingId/ll88_/$ll88SubmissionId/",
)({
  component: LL88SubmissionRoute,
});
